// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBfur1yIHdOpWc1jsRPvp3yAEVQKjPbzlU",
  authDomain: "alaa-9e2c0.firebaseapp.com",
  projectId: "alaa-9e2c0",
  storageBucket: "alaa-9e2c0.firebasestorage.app",
  messagingSenderId: "303302527997",
  appId: "1:303302527997:web:581e8a65304b31d4986794",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
